import {
    IS_LOADING,
    PLAYER_MANAGER_LIST_SUCCESS, PLAYER_MANAGER_LIST_ERROR,
    PLAYER_MANAGER_UPDATE_SUCCESS, PLAYER_MANAGER_UPDATE_ERROR,
    PLAYER_MANAGER_FILTER_SUCCESS, PLAYER_MANAGER_FILTER_ERROR,
    PLAYER_MANAGER_FILTER_LIST_SUCCESS, PLAYER_MANAGER_FILTER_LIST_ERROR
} from '../actions/Type';

const initialState = {
    player_manager_list: {},
    player_manager_edit: {},
    loading: false,
    player_manager_filter_list: {}
};

export const PlayerManagerReducers = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PLAYER_MANAGER_LIST_SUCCESS:
            return {
                ...state,
                player_manager_list: payload,
                loading: false,
            };
        case PLAYER_MANAGER_LIST_ERROR:
            return {
                ...state,
                player_manager_list: payload,
                loading: false,
            };

        case PLAYER_MANAGER_FILTER_LIST_SUCCESS:
            return {
                ...state,
                player_manager_filter_list: payload,
                loading: false,
            };
        case PLAYER_MANAGER_FILTER_LIST_ERROR:
            return {
                ...state,
                player_manager_filter_list: payload,
                loading: false,
            };

        case PLAYER_MANAGER_UPDATE_SUCCESS:
            return {
                ...state,
                player_manager_edit: payload,
                loading: false,
            };
        case PLAYER_MANAGER_UPDATE_ERROR:
            return {
                ...state,
                player_manager_edit: payload,
                loading: false,
            };

        case PLAYER_MANAGER_FILTER_SUCCESS:
            return {
                ...state,
                player_manager_list: payload,
                loading: false,
            };
        case PLAYER_MANAGER_FILTER_ERROR:
            return {
                ...state,
                player_manager_list: payload,
                loading: false,
            };
        default:
            return state;
    }
};
